/**
 * Converts a given time in 24-hour format to a human-readable 12-hour format string.
 * @param {string} militaryTime - A string representing the time in 24-hour format (HH:MM).
 * @returns {string} The time in 12-hour format (HH:MM AM/PM).
 */

export function convertToFormattedTime(militaryTime: string): string {
    const timeArray = militaryTime.split(':');
    const hours = parseInt(timeArray[0], 10);
    const minutes = parseInt(timeArray[1], 10);

    // Ensure hours and minutes are within valid ranges
    const formattedHours = hours >= 0 && hours <= 23 ? (hours % 12 || 12) : 12;
    const formattedMinutes = minutes >= 0 && minutes <= 59 ? (minutes < 10 ? `0${minutes}` : `${minutes}`) : '00';

    // Determine AM/PM
    const period = hours >= 12 ? 'PM' : 'AM';

    // Construct the final time string
    const finalTime: string = `${formattedHours}:${formattedMinutes} ${period}`;

    return finalTime;
}